import Button, { ButtonWrapper } from 'blocks/Button';
import Modal from 'components/Modal';
import { ModalFC } from 'config/types';
import { ModalVeriKidesProps } from 'pages/signup/signup.interface';
import { useTranslation } from 'react-i18next';
import * as S from './modalVerifyKides.styles';

const ModalVerifyKides: ModalFC<ModalVeriKidesProps> = ({ open, onClose, setNotificationMessageParent }) => {
  const { t } = useTranslation();

  return (
    <Modal open={open} onClose={onClose}>
      <S.Wrapper>
        <p>{t('pages.signup.sections.verification.fields.verifyKides.text')} </p>
        <ButtonWrapper justify="center">
          <Button
            onClick={() => {
              setNotificationMessageParent(true);
              onClose && onClose();
            }}
          >
            {t('pages.signup.sections.verification.fields.verifyKides.btn')}
          </Button>
        </ButtonWrapper>
      </S.Wrapper>
    </Modal>
  );
};

export default ModalVerifyKides;
